import { JobApplicationFormFieldLabel } from '@/graphql/generated';

export const fieldsToParse = ['firstName', 'lastName', 'email', 'cvDoc', 'otherDocs', 'phone', 'comments'] as const;

type FieldsToParse = (typeof fieldsToParse)[number];

export const formFieldLabelByName: Record<FieldsToParse, JobApplicationFormFieldLabel> = {
  firstName: JobApplicationFormFieldLabel.FirstName,
  lastName: JobApplicationFormFieldLabel.LastName,
  email: JobApplicationFormFieldLabel.Email,
  cvDoc: JobApplicationFormFieldLabel.UserCv,
  otherDocs: JobApplicationFormFieldLabel.Attachments,
  phone: JobApplicationFormFieldLabel.Phone,
  comments: JobApplicationFormFieldLabel.Comments,
};
